import { render } from "./Error404.vue?vue&type=template&id=9bb5ba00&scoped=true"
import script from "../js/error404.js?vue&type=script&lang=js"
export * from "../js/error404.js?vue&type=script&lang=js"

import "./Error404.vue?vue&type=style&index=0&id=9bb5ba00&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bb5ba00"]])

export default __exports__